import React, { Component } from 'react';
import axios from 'axios';

class Form extends React.Component{
constructor(props){
  super(props)
  this.state = {
    price: []
  }
}

componentDidMount(){
  axios.get(' https://taktiko-quoter-nu4c57wzlq-an.a.run.app/api-quoter/quote?name=yosimar&email=cmyosimar@gmail.com&from=malasia&to=australia&size=medio&date=2020-06-27')
  .then(response => {
    console.log(response)
    this.setState({price: response.data})
  })
  .catch(error => {
    console.log(error)
  })
}
render() {
  const { price } = this.state
  return(
    <div>
      <p>{JSON.stringify(this.state)}</p>
    </div>
  )
}

}


    


export default Form;